<template>
    <svg
        height="512px"
        style="enable-background: new 0 0 512 512"
        viewBox="0 0 512 512"
        width="512px"
        xml:space="preserve"
    >
        <g class="st1" id="layer">
            <rect class="st0" height="188" width="188" x="51" y="51" />
            <rect class="st0" height="188" width="188" x="273" y="51" />
            <rect class="st0" height="188" width="188" x="51" y="273" />
            <rect class="st0" height="188" width="188" x="273" y="273" />
        </g>
        <g id="layer_copy">
            <g>
                <path
                    d="M239,247H51c-4.418,0-8-3.582-8-8V51c0-4.418,3.582-8,8-8h188c4.418,0,8,3.582,8,8v188C247,243.418,243.418,247,239,247z     M59,231h172V59H59V231z"
                />
            </g>
            <g>
                <path
                    d="M461,247H273c-4.418,0-8-3.582-8-8V51c0-4.418,3.582-8,8-8h188c4.418,0,8,3.582,8,8v188C469,243.418,465.418,247,461,247z     M281,231h172V59H281V231z"
                />
            </g>
            <g>
                <path
                    d="M239,469H51c-4.418,0-8-3.582-8-8V273c0-4.418,3.582-8,8-8h188c4.418,0,8,3.582,8,8v188C247,465.418,243.418,469,239,469z     M59,453h172V281H59V453z"
                />
            </g>
            <g>
                <path
                    d="M461,469H273c-4.418,0-8-3.582-8-8V273c0-4.418,3.582-8,8-8h188c4.418,0,8,3.582,8,8v188C469,465.418,465.418,469,461,469    z M281,453h172V281H281V453z"
                />
            </g>
        </g>
    </svg>
</template>
<script>
export default {
    name: "Apps",
};
</script>
